import EditorJS, { OutputData } from "@editorjs/editorjs"
import React, { FC, useEffect, useRef } from "react"
import "./Editor.scss"
import { EDITOR_JS_TOOLS } from "./EditorToolConfig"
import { EDITOR_JS_I18N_CONFIG, EMPTY_OUTPUT_DATA } from "./utilities"

export type EditorProps = {
  onChange: (v: OutputData) => void
  placeHolder?: string
  initialValue?: OutputData
  style?: React.CSSProperties
}

export const EditorTextInput: FC<EditorProps> = ({
  onChange,
  placeHolder,
  initialValue = EMPTY_OUTPUT_DATA,
  style
}) => {
  const elementRef = useRef<HTMLDivElement>(null)

  // This will run only once
  useEffect(() => {
    const editorJs = new EditorJS({
      holder: elementRef.current!,
      data: initialValue ?? EMPTY_OUTPUT_DATA,
      placeholder: placeHolder,
      defaultBlock: "paragraph",
      inlineToolbar: true,
      tools: EDITOR_JS_TOOLS,
      i18n: EDITOR_JS_I18N_CONFIG,
      onChange: async () => {
        const content = await editorJs.saver?.save()
        if (content) onChange(content)
      }
    })

    return editorJs.destroy
  }, [])

  return <>{<div ref={elementRef} style={style} className="editor"></div>}</>
}
